(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  const phResponsiveHeaders = new WeakSet();
  function phFitHeaderMenus(root = document) {
    root.querySelectorAll('.header--middle-left:not(.drawer-menu)').forEach((header) => {
      if (phResponsiveHeaders.has(header)) return;
      const menu = header.querySelector('.header__inline-menu');
      const list = menu?.querySelector('.list-menu--inline');
      const logo = header.querySelector('.header__heading, .header__heading-link');
      const icons = header.querySelector('.header__icons');
      if (!menu || !list || !logo || !icons) return;
      phResponsiveHeaders.add(header);
      let frame;
      const fit = () => {
        if (!header.isConnected) {
          observer.disconnect();
          return;
        }
        const desktop = window.matchMedia('(min-width: 990px)').matches;
        const style = getComputedStyle(header);
        const available = header.getBoundingClientRect().width -
          parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const required = logo.getBoundingClientRect().width +
          icons.getBoundingClientRect().width + list.getBoundingClientRect().width + 56;
        const compact = desktop && required > available;
        const wasCompact = header.dataset.phCompact === 'true';
        if (compact !== wasCompact) {
          if (!compact) {
            const drawer = header.querySelector('header-drawer');
            if (drawer?.querySelector('details[open]')) drawer.closeMenuDrawer(new Event('resize'), false);
          } else {
            menu.querySelectorAll('header-menu').forEach((disclosure) => disclosure.close());
          }
        }
        header.dataset.phCompact = String(compact);
        menu.inert = compact || !desktop;
        document.documentElement.style.setProperty('--header-height',
          header.closest('.section-header').offsetHeight + 'px');
      };
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(fit);
      };
      const observer = new ResizeObserver(schedule);
      [header, logo, icons, list].forEach((element) => observer.observe(element));
      document.fonts.ready.then(schedule);
      fit();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => phFitHeaderMenus(), { once: true });
  } else {
    phFitHeaderMenus();
  }
  document.addEventListener('shopify:section:load', (event) => phFitHeaderMenus(event.target));

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('ph-unit-price')) {
    customElements.define('ph-unit-price', class extends HTMLElement {
      connectedCallback() {
        this.rows = {};
        (this.dataset.rows || '').split(',').forEach((row) => {
          const [id, grams, price] = row.split(':');
          if (id && grams && price) this.rows[id] = { grams: Number(grams), price: Number(price) };
        });
        this.rateOut = this.querySelector('[data-unit-rate]');
        this.hintOut = this.querySelector('[data-unit-hint]');
        this.product = this.closest('product-info') || document;
        this.render();
        this.observer = new MutationObserver(() => {
          window.clearTimeout(this.timer);
          this.timer = window.setTimeout(() => this.render(), 60);
        });
        this.observer.observe(this.product, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'checked', 'selected'] });
        this.product.addEventListener('change', () => this.render());
      }
      currentId() {
        const input = this.product.querySelector('form[data-type="add-to-cart-form"] input[name="id"], product-form input[name="id"]');
        if (input && input.value) return input.value;
        const params = new URLSearchParams(window.location.search);
        return params.get('variant');
      }
      money(pence) {
        const symbol = this.dataset.currency || '£';
        return symbol + (Math.round(pence) / 100).toFixed(2);
      }
      render() {
        const row = this.rows[this.currentId()];
        if (!row || !row.grams) { this.hidden = true; return; }
        this.hidden = false;
        const rate = row.price * 100 / row.grams;
        let rateText = this.money(rate) + ' per 100g';
        const gpc = Number(this.dataset.gpc || 0);
        if (gpc > 0) {
          const cups = Math.floor(row.grams / gpc);
          if (cups >= 5) {
            const perCup = row.price / cups;
            const cupText = perCup < 100 ? Math.max(1, Math.round(perCup)) + 'p' : this.money(perCup);
            rateText += ' · about ' + cups + ' cups, roughly ' + cupText + ' a cup';
          }
        }
        if (this.rateOut.textContent !== rateText) this.rateOut.textContent = rateText;
        const best = Number(this.dataset.bestRate || 0);
        let hint = '';
        if (best && rate - best > 1) {
          hint = 'Bigger pouches cost less per cup: ' + this.dataset.bestLabel + ' works out at ' + this.money(best) + ' per 100g.';
        } else if (best && Object.keys(this.rows).length > 1) {
          hint = 'Best value per cup.';
        }
        if (this.hintOut.textContent !== hint) this.hintOut.textContent = hint;
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-autumn-window"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ph-seasonal-slider')) {
  customElements.define('ph-seasonal-slider', class extends HTMLElement {
    connectedCallback() {
      this.index = 0;
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.track = this.querySelector('.ph-seasonal-slider__track');
      this.dots = [...this.querySelectorAll('[data-hero-dot]')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true';
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      const on = (target,event,handler) => target.addEventListener(event,handler,options);
      this.dots.forEach((dot,index)=>on(dot,'click',()=>this.show(index,true)));
      on(this,'mouseenter',()=>{this.hovered=true;this.schedule();});
      on(this,'mouseleave',()=>{this.hovered=false;this.schedule();});
      on(this,'focusin',()=>{this.focused=true;this.schedule();});
      on(this,'focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.schedule();}});
      on(this,'keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1),true);}});
      on(this,'touchstart',event=>{this.startX=event.touches[0].clientX;this.startY=event.touches[0].clientY;});
      on(this,'touchend',event=>{const dx=event.changedTouches[0].clientX-this.startX;const dy=event.changedTouches[0].clientY-this.startY;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)this.show(this.index+(dx<0?1:-1),true);});
      on(document,'visibilitychange',()=>this.schedule());
      on(this.motion,'change',()=>{this.schedule();});
      this.observer = new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.schedule();},{threshold:.15});
      this.observer.observe(this);
    }
    show(index,manual=false){
      this.index=(index+this.slides.length)%this.slides.length;
      this.track.style.transform=`translateX(-${this.index*100}%)`;
      this.slides.forEach((slide,i)=>{slide.inert=i!==this.index;slide.setAttribute('aria-hidden',String(i!==this.index));});
      this.dots.forEach((dot,i)=>{if(i===this.index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
      
      this.schedule();
    }
    schedule(){clearTimeout(this.timer);if(!this.paused&&!this.hovered&&!this.focused&&this.inView&&!document.hidden&&!this.motion.matches)this.timer=setTimeout(()=>this.show(this.index+1),Number(this.dataset.interval)||5000);}
    disconnectedCallback(){clearTimeout(this.timer);this.events?.abort();this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-brew-school"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ph-brew-school')) {
    customElements.define('ph-brew-school', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.workbench = this.querySelector('.ph-brew__workbench');
        if (!this.workbench) return;
        this.form = this.querySelector('form');
        this.family = this.form.elements.family;
        this.water = this.form.elements.water;
        this.duration = this.querySelector('[name="duration"]');
        this.clock = this.querySelector('[data-countdown]');
        this.toggle = this.querySelector('[data-toggle-timer]');
        this.status = this.querySelector('[data-timer-status]');
        this.error = this.querySelector('[data-calculator-error]');
        this.state = 'ready';
        this.workbench.hidden = false;
        this.form.addEventListener('submit', event => event.preventDefault(), options);
        this.family.addEventListener('change', () => this.updateRecipe(true), options);
        this.water.addEventListener('input', () => this.updateRecipe(false), options);
        this.duration.addEventListener('change', () => this.resetTimer(true), options);
        this.toggle.addEventListener('click', () => this.toggleTimer(), options);
        this.querySelector('[data-reset-timer]').addEventListener('click', () => this.resetTimer(true), options);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible' && this.state === 'running') this.tick();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const details = event.target.closest('details');
          if (details) details.open = true;
        }, options);
        this.updateRecipe(true, false);
      }
      updateRecipe(changeFamily, announce = true) {
        const selected = this.family.selectedOptions[0];
        const water = Number(this.water.value);
        const valid = this.water.checkValidity() && Number.isFinite(water);
        this.error.textContent = valid ? '' : this.dataset.volumeInvalid;
        this.water.setAttribute('aria-invalid', String(!valid));
        const dose = Number(selected.dataset.dose) * water / 250;
        this.querySelector('[data-leaf-output]').textContent = valid ? new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { maximumFractionDigits: 1 }).format(dose) : '—';
        this.querySelector('[data-temperature-output]').textContent = selected.dataset.temperature;
        this.querySelector('[data-recipe-note]').textContent = selected.dataset.note;
        if (changeFamily) {
          this.duration.value = String(Number(selected.dataset.seconds) / 60);
          this.resetTimer(announce);
        }
      }
      validDuration() {
        const valid = this.duration.checkValidity() && Number.isFinite(Number(this.duration.value));
        this.duration.setAttribute('aria-invalid', String(!valid));
        if (!valid) this.status.textContent = this.dataset.durationInvalid;
        return valid;
      }
      resetTimer(announce) {
        clearInterval(this.interval);
        this.interval = null;
        this.state = 'ready';
        this.toggle.textContent = this.dataset.start;
        if (!this.validDuration()) {
          this.remaining = 0;
          this.clock.textContent = '—:—';
          return;
        }
        this.remaining = Number(this.duration.value) * 60000;
        this.renderTime();
        this.status.textContent = announce ? this.dataset.resetMessage : '';
      }
      toggleTimer() {
        if (this.state === 'running') {
          this.remaining = Math.max(0, this.deadline - Date.now());
          if (this.remaining === 0) {
            this.finish();
            return;
          }
          clearInterval(this.interval);
          this.interval = null;
          this.state = 'paused';
          this.toggle.textContent = this.dataset.resume;
          this.status.textContent = this.dataset.paused;
          this.renderTime();
          return;
        }
        if (!this.validDuration()) {
          this.duration.focus();
          return;
        }
        if (this.state === 'ready' || this.state === 'complete') this.remaining = Number(this.duration.value) * 60000;
        this.deadline = Date.now() + this.remaining;
        this.state = 'running';
        this.toggle.textContent = this.dataset.pause;
        this.status.textContent = this.dataset.started;
        this.interval = setInterval(() => this.tick(), 250);
        this.tick();
      }
      tick() {
        this.remaining = Math.max(0, this.deadline - Date.now());
        this.renderTime();
        if (this.remaining === 0) this.finish();
      }
      renderTime() {
        const seconds = Math.ceil(this.remaining / 1000);
        this.clock.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      }
      finish() {
        clearInterval(this.interval);
        this.interval = null;
        this.state = 'complete';
        this.remaining = 0;
        this.renderTime();
        this.toggle.textContent = this.dataset.start;
        this.status.textContent = this.dataset.complete;
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ph-tea-view'))customElements.define('ph-tea-view',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();
    const tabs=[...this.querySelectorAll('[role=tab]')];
    if(tabs.length<2){this.querySelector('[role=tabpanel]')?.removeAttribute('aria-labelledby');return;}
    this.querySelector('[role=tablist]').hidden=false;
    const select=(index,focus=false)=>{
      tabs.forEach((tab,i)=>{const active=i===index;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;const panel=this.querySelector('#'+CSS.escape(tab.getAttribute('aria-controls')));panel.hidden=!active;if(active&&this.dataset.motion==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches){panel.getAnimations().forEach(a=>a.cancel());panel.animate([{opacity:.3,transform:'scale(1.04)'},{opacity:1,transform:'scale(1)'}],{duration:420,easing:'cubic-bezier(.2,.65,.3,1)'});}});
      if(focus)tabs[index].focus();
    };
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>select(index),{signal:this.controller.signal});
      tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(next,true);},{signal:this.controller.signal});
    });
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-referral-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ph-share-shop')) {
    customElements.define('ph-share-shop', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('button')?.addEventListener('click', async () => {
          const payload = { title: this.dataset.title, text: this.dataset.text, url: this.dataset.url };
          try {
            if (navigator.share) await navigator.share(payload);
            else await navigator.clipboard.writeText(this.dataset.url);
            const status = this.querySelector('[role="status"]');
            if (status) status.textContent = this.dataset.success;
          } catch (error) {
            if (error && error.name !== 'AbortError') window.location.href = this.dataset.url;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-social-feed"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ph-social-slideshow')){customElements.define('ph-social-slideshow',class extends HTMLElement{connectedCallback(){this.slides=[...this.querySelectorAll('[data-slide]')];this.dots=[...this.querySelectorAll('[data-dot]')];if(this.slides.length<2)return;this.index=0;this.track=this.querySelector('.ph-social-feed__track');this.reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;this.show=index=>{this.index=(index+this.slides.length)%this.slides.length;this.track.style.transform=`translate3d(-${this.index*100}%,0,0)`;this.slides.forEach((slide,i)=>slide.setAttribute('aria-hidden',i===this.index?'false':'true'));this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',i===this.index?'true':'false'))};this.querySelector('[data-previous]')?.addEventListener('click',()=>{this.show(this.index-1);this.restart()});this.querySelector('[data-next]')?.addEventListener('click',()=>{this.show(this.index+1);this.restart()});this.dots.forEach(dot=>dot.addEventListener('click',()=>{this.show(Number(dot.dataset.dot));this.restart()}));this.addEventListener('mouseenter',()=>this.stop());this.addEventListener('mouseleave',()=>this.start());this.addEventListener('focusin',()=>this.stop());this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget))this.start()});this.visibility=()=>document.hidden?this.stop():this.start();document.addEventListener('visibilitychange',this.visibility);this.start()}disconnectedCallback(){this.stop();document.removeEventListener('visibilitychange',this.visibility)}start(){if(this.reduced||this.dataset.autoplay!=='true'||document.hidden||this.matches(':hover')||this.contains(document.activeElement))return;this.stop();this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.interval)||5000)}stop(){if(this.timer)clearInterval(this.timer);this.timer=null}restart(){this.stop();this.start()}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-stockist-map"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stockist-locator')) {
  customElements.define('stockist-locator', class extends HTMLElement {
    async connectedCallback() {
      this.mapElement = this.querySelector('[data-stockist-map]');
      if (!this.mapElement) return;
      this.mapName = this.querySelector('[data-map-name]');
      this.mapLocation = this.querySelector('[data-map-location]');
      this.mapExternal = this.querySelector('[data-map-external]');
      this.buttons = Array.from(this.querySelectorAll('[data-map-lat][data-map-lng]'));
      this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button)));
      await this.loadLeaflet();
      this.createMap();
    }

    loadLeaflet() {
      if (window.L) return Promise.resolve();
      if (window.phLeafletPromise) return window.phLeafletPromise;
      window.phLeafletPromise = new Promise((resolve, reject) => {
        if (!document.querySelector('link[data-ph-leaflet]')) {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
          stylesheet.dataset.phLeaflet = '';
          document.head.appendChild(stylesheet);
        }
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        script.dataset.phLeaflet = '';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return window.phLeafletPromise;
    }

    createMap() {
      if (this.map || !window.L) return;
      this.map = window.L.map(this.mapElement, { scrollWheelZoom: false });
      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.map);
      this.markers = new Map();
      const markerList = [];
      this.buttons.forEach((button, index) => {
        const latitude = Number(button.dataset.mapLat);
        const longitude = Number(button.dataset.mapLng);
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
        const markerIcon = window.L.divIcon({
          className: 'ph-locator__marker',
          html: `<span>${index + 1}</span>`,
          iconSize: [32, 32],
          iconAnchor: [16, 28],
          popupAnchor: [0, -25]
        });
        const marker = window.L.marker([latitude, longitude], { icon: markerIcon }).addTo(this.map);
        const popup = document.createElement('div');
        const name = document.createElement('strong');
        const location = document.createElement('span');
        const link = document.createElement('a');
        name.textContent = button.dataset.mapName;
        location.textContent = button.dataset.mapLocation;
        link.textContent = button.dataset.mapLinkLabel;
        link.href = button.dataset.mapUrl;
        link.target = '_blank';
        link.rel = 'noopener';
        popup.append(name, location, link);
        marker.bindPopup(popup);
        this.markers.set(button, marker);
        markerList.push(marker);
      });
      if (markerList.length) {
        const bounds = window.L.featureGroup(markerList).getBounds();
        this.map.fitBounds(bounds, { padding: [42, 42], maxZoom: 9 });
      }
    }

    select(button) {
      this.mapName.textContent = button.dataset.mapName;
      this.mapLocation.textContent = button.dataset.mapLocation;
      this.mapExternal.href = button.dataset.mapUrl;
      this.mapExternal.hidden = false;
      this.buttons.forEach((item) => {
        const selected = item === button;
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        item.closest('[data-stockist-card]')?.classList.toggle('is-selected', selected);
      });
      this.markers?.get(button)?.openPopup();
      this.mapElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-tea-finder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ph-catalogue-finder')){customElements.define('ph-catalogue-finder',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;if(!this.querySelector('[data-grid]')||!this.querySelector('[data-search]'))return;this.cards=[...this.querySelectorAll('[data-tea]')];this.buttons=[...this.querySelectorAll('[data-filter-group]')];this.search=this.querySelector('[data-search]');this.sort=this.querySelector('[data-sort]');this.available=this.querySelector('[data-available]');this.grid=this.querySelector('[data-grid]');this.count=this.querySelector('[data-count]');this.empty=this.querySelector('[data-empty]');this.more=this.querySelector('[data-more]');this.active=this.querySelector('[data-active]');this.pageSize=Number(this.dataset.pageSize)||24;this.limit=this.pageSize;this.momentMap={morning:['breakfast','energising','focus','high-caffeine'],unwind:['sleep','calming','relaxing','caffeine-free'],['after-meal']:['digestive','digestion','mint','peppermint','ginger'],iced:['summer','iced','refreshing','fruity']};this.buttons.forEach(b=>b.addEventListener('click',()=>this.toggle(b)));this.search.addEventListener('input',()=>{this.limit=this.pageSize;this.apply()});this.sort.addEventListener('change',()=>this.apply());this.available.addEventListener('change',()=>{this.limit=this.pageSize;this.apply()});this.querySelectorAll('[data-clear],[data-clear-empty]').forEach(b=>b.addEventListener('click',()=>this.clear()));this.more.addEventListener('click',()=>{this.limit+=this.pageSize;this.apply(false)});this.restore();this.apply(false)}toggle(button){const active=button.getAttribute('aria-pressed')==='true';if(button.hasAttribute('data-single'))this.buttons.filter(b=>b.dataset.filterGroup===button.dataset.filterGroup).forEach(b=>b.setAttribute('aria-pressed','false'));button.setAttribute('aria-pressed',String(!active));this.limit=this.pageSize;this.apply()}groups(){const groups={};this.buttons.filter(b=>b.getAttribute('aria-pressed')==='true').forEach(b=>(groups[b.dataset.filterGroup]??=[]).push(b.dataset.filter));return groups}matchesMap(tags,values,map){return values.some(value=>(map[value]||[value]).some(token=>tags.includes(token)))}matchesTaste(card,values){const tastes=(card.dataset.finderTastes||'').split(' ').filter(Boolean);return values.some(value=>tastes.includes(value))}apply(updateUrl=true){const groups=this.groups();const query=this.search.value.trim().toLowerCase();let matches=this.cards.filter(card=>{if(query&&!card.dataset.search.includes(query))return false;if(this.available.checked&&card.dataset.available!=='true')return false;if(groups.type&&!groups.type.includes(card.dataset.type))return false;if(groups.caffeine){const caffeineMatch=groups.caffeine.includes('free-decaf')?card.dataset.caffeine==='free'||card.dataset.caffeine==='decaf':groups.caffeine.includes(card.dataset.caffeine);if(!caffeineMatch)return false}if(groups.taste&&!this.matchesTaste(card,groups.taste))return false;if(groups.moment&&!this.matchesMap(card.dataset.tags,groups.moment,this.momentMap))return false;return true});this.wheelMatches=matches;this.dispatchEvent(new CustomEvent('ph:finder-updated'));const mode=this.sort.value;matches.sort((a,b)=>mode==='alpha'?a.dataset.name.localeCompare(b.dataset.name):mode==='price-asc'?Number(a.dataset.price)-Number(b.dataset.price):mode==='price-desc'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.order)-Number(b.dataset.order));const visible=new Set(matches.slice(0,this.limit));const fragment=document.createDocumentFragment();matches.forEach(card=>fragment.appendChild(card));this.cards.filter(card=>!matches.includes(card)).forEach(card=>fragment.appendChild(card));this.grid.appendChild(fragment);this.cards.forEach(card=>card.hidden=!visible.has(card));this.count.textContent=matches.length===1?this.dataset.countOne:this.dataset.countMany.replace('__COUNT__',String(matches.length));this.empty.hidden=matches.length>0;this.more.hidden=matches.length<=this.limit;this.renderActive(groups);if(updateUrl)this.save(groups)}renderActive(groups){this.active.innerHTML='';const selected=this.buttons.filter(b=>b.getAttribute('aria-pressed')==='true');selected.forEach(button=>{const chip=document.createElement('button');chip.type='button';chip.textContent=button.textContent.trim()+' ×';chip.addEventListener('click',()=>this.toggle(button));this.active.appendChild(chip)});if(this.search.value.trim()){const chip=document.createElement('button');chip.type='button';chip.textContent='“'+this.search.value.trim()+'” ×';chip.addEventListener('click',()=>{this.search.value='';this.apply()});this.active.appendChild(chip)}this.active.hidden=!this.active.children.length}clear(){this.buttons.forEach(b=>b.setAttribute('aria-pressed','false'));this.search.value='';this.available.checked=false;this.sort.value='recommended';this.limit=this.pageSize;this.apply();this.search.focus()}save(groups){const params=new URLSearchParams;Object.entries(groups).forEach(([group,values])=>params.set(group,values.join(',')));if(this.search.value.trim())params.set('q',this.search.value.trim());if(this.sort.value!=='recommended')params.set('sort',this.sort.value);if(this.available.checked)params.set('available','1');const url=new URL(location.href);url.search=params.toString();history.replaceState({},'',url)}restore(){const params=new URLSearchParams(location.search);this.buttons.forEach(button=>{const values=(params.get(button.dataset.filterGroup)||'').split(',');if(values.includes(button.dataset.filter)||button.dataset.filter==='free-decaf'&&(values.includes('free')||values.includes('decaf')))button.setAttribute('aria-pressed','true')});this.search.value=params.get('q')||'';if([...this.sort.options].some(o=>o.value===params.get('sort')))this.sort.value=params.get('sort');this.available.checked=params.get('available')==='1'}});}
if(!window.phFinderPresets){window.phFinderPresets=true;document.addEventListener('click',e=>{if(e.target.closest('[data-filter-group],[data-clear],[data-clear-empty],.ph-cf-active button')){const f=e.target.closest('ph-catalogue-finder');if(f)f.querySelectorAll('[data-preset]').forEach(c=>c.setAttribute('aria-pressed','false'))}},true);document.addEventListener('click',e=>{const chip=e.target.closest('[data-preset]');if(!chip)return;const f=chip.closest('ph-catalogue-finder');if(!f||!f.buttons)return;const on=chip.getAttribute('aria-pressed')==='true';f.querySelectorAll('[data-preset]').forEach(c=>c.setAttribute('aria-pressed','false'));f.buttons.forEach(b=>b.setAttribute('aria-pressed','false'));f.search.value='';if(!on){new URLSearchParams(chip.dataset.preset).forEach((v,k)=>v.split(',').forEach(val=>{const b=f.buttons.find(x=>x.dataset.filterGroup===k&&x.dataset.filter===val);if(b){b.setAttribute('aria-pressed','true');const d=b.closest('details');if(d)d.open=true}}));chip.setAttribute('aria-pressed','true')}f.limit=f.pageSize;f.apply();const bar=f.querySelector('.ph-cf-results-bar');if(bar&&window.matchMedia('(max-width: 989px)').matches)bar.scrollIntoView({behavior:'smooth',block:'start'})});}
if (!customElements.get('ph-tea-wheel')) {
  customElements.define('ph-tea-wheel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.finder = this.closest('ph-catalogue-finder');
      this.q = name => this.querySelector('[data-wheel-' + name + ']');
      this.strings = JSON.parse(this.dataset.strings);
      this.spinButton = this.q('spin');
      this.hubButton = this.q('hub');
      this.spinFromHub = () => this.spin();
      this.scope = this.q('scope');
      this.disc = this.q('disc');
      this.seen = new Set();
      try { this.seen = new Set(JSON.parse(localStorage.getItem('ph-tea-wheel-v1') || '[]')); } catch (_) {}
      this.onFilter = () => { if (!this.busy) this.update(); };
      this.finder.addEventListener('ph:finder-updated', this.onFilter);
      this.scope.addEventListener('change', this.onFilter);
      this.spinButton.addEventListener('click', this.spinFromHub);
      this.hubButton.addEventListener('click', this.spinFromHub);
      this.update();
    }
    disconnectedCallback() {
      this.finder?.removeEventListener('ph:finder-updated', this.onFilter);
      this.scope?.removeEventListener('change', this.onFilter);
      this.spinButton?.removeEventListener('click', this.spinFromHub);
      this.hubButton?.removeEventListener('click', this.spinFromHub);
      this.animation?.cancel();
      clearInterval(this.tickerTimer);
      clearTimeout(this.finishTimer);
      this.ready = false;
    }
    randomInt(max) {
      if (globalThis.crypto?.getRandomValues) {
        const value = new Uint32Array(1);
        const limit = 4294967296 - 4294967296 % max;
        do { crypto.getRandomValues(value); } while (value[0] >= limit);
        return value[0] % max;
      }
      return Math.floor(Math.random() * max);
    }
    shuffle(items) {
      const copy = [...items];
      for (let i = copy.length - 1; i > 0; i--) {
        const j = this.randomInt(i + 1);
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }
      return copy;
    }
    pool() {
      const cards = this.scope.checked ? this.finder.wheelMatches : this.finder.cards;
      return (cards || [...this.finder.querySelectorAll('[data-tea]')]).filter(card => card.dataset.available === 'true');
    }
    update() {
      const pool = this.pool();
      this.q('pick').hidden = true;
      this.q('placeholder').hidden = false;
      this.q('ticker').textContent = this.strings.ticker;
      this.spinButton.disabled = pool.length === 0;
      this.hubButton.disabled = pool.length === 0;
      this.drawLegend(pool);
      this.q('pool').textContent = (this.scope.checked ? this.strings.pool_filtered : this.strings.pool_all).replace('__COUNT__', pool.length);
      this.q('status').textContent = pool.length ? this.strings.start : this.strings.empty;
      this.q('hub-label').textContent = this.last ? this.strings.again : this.strings.push;
      this.draw(this.shuffle(pool).slice(0, 8));
    }

    teaColor(type) {
      const families = {'black-tea':'black','green-tea':'green','herbal-tea':'herbal','fruit-herbal-tea':'herbal','fruit-tea':'fruit','rooibos-tea':'rooibos','rooibos':'rooibos','oolong-tea':'oolong','white-tea':'white','matcha':'matcha','yellow-tea':'yellow','pu-erh-tea':'puerh'};
      const fallback = {black:'#52182A',green:'#28583F',herbal:'#AF2846',fruit:'#C04465',rooibos:'#B54C19',oolong:'#735095',white:'#807087',matcha:'#6B8C21',yellow:'#B99700',puerh:'#453124',neutral:'#625E56'};
      const family = families[type] || 'neutral';
      return getComputedStyle(this).getPropertyValue('--ph-family-' + family).trim() || fallback[family];
    }
    labelColor(type) {
      const color = this.teaColor(type);
      if (!/^#[0-9a-f]{6}$/i.test(color)) return '#ffffff';
      const rgb = color.slice(1).match(/../g).map(channel => parseInt(channel,16) / 255).map(value => value <= .04045 ? value / 12.92 : Math.pow((value + .055) / 1.055, 2.4));
      const luminance = rgb[0] * .2126 + rgb[1] * .7152 + rgb[2] * .0722;
      return (luminance + .05) / .05 > 1.05 / (luminance + .05) ? '#000000' : '#ffffff';
    }
    typeLabel(type) {
      return this.finder.buttons?.find(button => button.dataset.filterGroup === 'type' && button.dataset.filter === type)?.textContent.trim() || type.replaceAll('-', ' ');
    }
    drawLegend(pool) {
      const legend = this.q('legend');
      legend.replaceChildren();
      const types = [...new Set(pool.map(card => card.dataset.type))];
      for (const type of types) {
        const item = document.createElement('li');
        const dot = document.createElement('span');
        dot.style.backgroundColor = this.teaColor(type);
        dot.setAttribute('aria-hidden', 'true');
        item.append(dot, document.createTextNode(this.typeLabel(type)));
        legend.appendChild(item);
      }
    }
    wrapTitle(title, limit = 18) {
      const lines = [];
      let line = '';
      for (const word of title.split(/\s+/)) {
        if (line && (line + ' ' + word).length > limit) { lines.push(line); line = ''; }
        if (word.length > limit) {
          if (line) { lines.push(line); line = ''; }
          for (let offset = 0; offset < word.length; offset += limit) lines.push(word.slice(offset, offset + limit));
        } else line += (line ? ' ' : '') + word;
      }
      if (line) lines.push(line);
      return lines;
    }
    draw(cards) {
      this.disc.replaceChildren();
      this.disc.style.transform = 'rotate(0deg)';
      const ns = 'http://www.w3.org/2000/svg';
      const count = cards.length || 8;
      const step = 360 / count;
      for (let i = 0; i < count; i++) {
        const a = (i * step - 90) * Math.PI / 180;
        const b = ((i + 1) * step - 90) * Math.PI / 180;
        const path = document.createElementNS(ns, 'path');
        path.setAttribute('d', count === 1 ? 'M220 0a220 220 0 1 1 0 440a220 220 0 1 1 0-440' : `M220 220L${220 + 219 * Math.cos(a)} ${220 + 219 * Math.sin(a)}A219 219 0 ${step > 180 ? 1 : 0} 1 ${220 + 219 * Math.cos(b)} ${220 + 219 * Math.sin(b)}Z`);
        path.setAttribute('fill', this.teaColor(cards[i]?.dataset.type));
        path.setAttribute('stroke', '#fff8ed');
        path.setAttribute('stroke-width', '1.8');
        path.dataset.wheelSegment = String(i);
        this.disc.appendChild(path);
        const group = document.createElementNS(ns, 'g');
        const angle = i * step + step / 2 - 90;
        const flip = angle > 90 && angle < 270;
        group.setAttribute('transform', `translate(220 220) rotate(${angle}) translate(148 0) rotate(${flip ? 180 : 0})`);
        const text = document.createElementNS(ns, 'text');
        text.setAttribute('text-anchor', 'middle');
        text.setAttribute('fill', this.labelColor(cards[i]?.dataset.type));
        text.setAttribute('font-size', '11.5');
        const title = cards[i]?.dataset.name || 'Porter Hill';
        const lines = this.wrapTitle(title);
        lines.forEach((line, lineIndex) => {
          const span = document.createElementNS(ns, 'tspan');
          span.setAttribute('x', '0');
          span.setAttribute('y', String((lineIndex - (lines.length - 1) / 2) * 13 + 4));
          span.textContent = line;
          text.appendChild(span);
        });
        const tooltip = document.createElementNS(ns, 'title');
        tooltip.textContent = title;
        group.append(tooltip, text);
        this.disc.appendChild(group);
        const bounds = text.getBBox();
        const scale = Math.min(1, 128 / Math.max(bounds.width, 1), 65 / Math.max(bounds.height, 1));
        if (scale < 1) text.setAttribute('transform', `scale(${scale})`);
      }
    }
    spin() {
      if (this.busy) return;
      const pool = this.pool();
      if (!pool.length) return this.update();
      let unseen = pool.filter(card => !this.seen.has(card.dataset.wheelUrl));
      if (!unseen.length) {
        pool.forEach(card => this.seen.delete(card.dataset.wheelUrl));
        unseen = pool.length > 1 ? pool.filter(card => card.dataset.wheelUrl !== this.last) : pool;
      }
      const chosen = unseen[this.randomInt(unseen.length)];
      const wedges = this.shuffle([chosen, ...this.shuffle(pool.filter(card => card !== chosen)).slice(0, 7)]);
      this.draw(wedges);
      const selected = wedges.indexOf(chosen);
      const angle = 1800 + 360 - (selected + .5) * (360 / wedges.length);
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const duration = reduced ? 80 : 4200;
      this.busy = true;
      this.setAttribute('data-spinning', '');
      this.spinButton.disabled = true;
      this.hubButton.disabled = true;
      this.scope.disabled = true;
      this.q('status').textContent = this.strings.spinning;
      this.q('hub-label').textContent = this.strings.turning;
      this.q('result').setAttribute('aria-busy', 'true');
      this.animation = this.disc.animate([{ transform: 'rotate(0deg)' }, { transform: `rotate(${angle}deg)` }], { duration, easing: 'cubic-bezier(.12,.65,.12,1)', fill: 'forwards' });
      const tickerCards = this.shuffle(pool);
      let tick = 0;
      if (!reduced) this.tickerTimer = setInterval(() => { this.q('ticker').textContent = tickerCards[tick++ % tickerCards.length].dataset.name; }, 130);
      this.finishTimer = setTimeout(() => {
        clearInterval(this.tickerTimer);
        this.disc.style.transform = `rotate(${angle % 360}deg)`;
        this.animation.cancel();
        this.seen.add(chosen.dataset.wheelUrl);
        this.last = chosen.dataset.wheelUrl;
        try { localStorage.setItem('ph-tea-wheel-v1', JSON.stringify([...this.seen].slice(-1000))); } catch (_) {}
        this.reveal(chosen);
        this.busy = false;
        this.removeAttribute('data-spinning');
        this.scope.disabled = false;
        this.spinButton.disabled = this.pool().length === 0;
        this.hubButton.disabled = this.spinButton.disabled;
        this.disc.querySelector('[data-wheel-segment="' + selected + '"]')?.setAttribute('stroke-width', '5');
        this.q('result').removeAttribute('aria-busy');
        this.q('status').textContent = this.strings.selected.replace('__NAME__', chosen.dataset.name);
        if (this.pool().length !== pool.length) this.q('pool').textContent = (this.scope.checked ? this.strings.pool_filtered : this.strings.pool_all).replace('__COUNT__', this.pool().length);
      }, duration + 30);
    }
    reveal(card) {
      const d = card.dataset;
      this.q('placeholder').hidden = true;
      this.q('pick').hidden = false;
      this.q('title').textContent = d.name;
      ['title', 'link', 'image-link'].forEach(key => { this.q(key).href = d.wheelUrl; });
      this.q('image').hidden = !d.wheelImage;
      if (d.wheelImage) this.q('image').src = d.wheelImage;
      this.q('notes').textContent = d.wheelNotes;
      this.q('price').textContent = d.wheelPrice;
      const type = this.finder.buttons.find(button => button.dataset.filterGroup === 'type' && button.dataset.filter === d.type)?.textContent.trim() || d.type.replaceAll('-', ' ');
      const caffeine = d.caffeine === 'free' ? this.strings.free : d.caffeine === 'decaf' ? this.strings.decaf : this.strings.caffeine;
      this.q('tag').textContent = type + ' · ' + caffeine;
      this.q('ticker').textContent = d.name;
      this.spinButton.firstChild.textContent = this.strings.again + ' ';
      this.q('hub-label').textContent = this.strings.again;
      this.hubButton.setAttribute('aria-label', this.strings.again);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-tea-reader"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ph-tea-reader')) {
  customElements.define('ph-tea-reader', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.chapters = [...this.querySelectorAll('[data-reader-chapter]')];
      this.search = this.querySelector('[data-reader-search]');
      this.status = this.querySelector('[data-reader-status]');
      this.querySelector('[data-reader-tools]').hidden = false;
      this.search.addEventListener('input', () => this.filter(), opts);
      this.querySelector('[data-reader-reset]').addEventListener('click', () => { this.search.value = ''; this.filter(); this.search.focus(); }, opts);
      this.querySelector('[data-reader-surprise]').addEventListener('click', () => {
        const available = this.chapters.filter(c => !c.hidden && c !== this.lastChapter);
        const chapter = available[Math.floor(Math.random() * available.length)] || this.chapters.find(c => !c.hidden);
        if (!chapter) return;
        this.lastChapter = chapter;
        chapter.open = true;
        chapter.querySelector('summary').focus();
        chapter.scrollIntoView({ block: 'start', behavior: 'auto' });
      }, opts);
      this.openHash = () => {
        const chapter = this.chapters.find(c => '#' + c.id === location.hash);
        if (!chapter) return;
        this.search.value = ''; this.filter(); chapter.open = true;
      };
      window.addEventListener('hashchange', this.openHash, opts);
      document.addEventListener('shopify:block:select', event => {
        const chapter = event.target.closest('[data-reader-chapter]');
        if (chapter && this.contains(chapter)) { this.search.value = ''; this.filter(); chapter.open = true; }
      }, opts);
      this.filter(); this.openHash();
    }
    filter() {
      const query = this.search.value.trim().toLocaleLowerCase();
      let count = 0;
      for (const chapter of this.chapters) {
        chapter.hidden = !chapter.textContent.toLocaleLowerCase().includes(query);
        if (!chapter.hidden) count++;
      }
      this.status.textContent = `${count} ${count === 1 ? 'chapter' : 'chapters'}`;
      this.querySelector('[data-reader-empty]').hidden = count !== 0;
      this.querySelector('[data-reader-surprise]').disabled = count === 0;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["porter-hill-tea-cocktails"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ph-recipe-filter'))customElements.define('ph-recipe-filter',class extends HTMLElement{
  connectedCallback(){
    this.abort?.abort();this.abort=new AbortController();
    this.cards=[...this.querySelectorAll('[data-recipe-card]')];
    this.styleControl=this.querySelector('[data-recipe-style]');
    this.caffeineControl=this.querySelector('[data-recipe-caffeine]');
    this.status=this.querySelector('[data-recipe-status]');
    this.empty=this.querySelector('[data-recipe-empty]');
    this.querySelectorAll('[data-enhance]').forEach(element=>element.hidden=false);
    [this.styleControl,this.caffeineControl].filter(Boolean).forEach(control=>control.addEventListener('change',()=>this.render(),{signal:this.abort.signal}));
    this.addEventListener('shopify:block:select',event=>this.revealSelectedBlock(event),{signal:this.abort.signal});
    this.render();
  }
  disconnectedCallback(){this.abort?.abort()}
  revealSelectedBlock(event){
    const card=event.target.closest?.('[data-recipe-card]');
    if(!card)return;
    if(this.styleControl)this.styleControl.value='all';
    if(this.caffeineControl)this.caffeineControl.value='all';
    this.render();
    const details=card.querySelector('details');
    if(details)details.open=true;
  }
  render(){
    const style=this.styleControl?.value||'all';
    const caffeine=this.caffeineControl?.value||'all';
    let visible=0;
    this.cards.forEach(card=>{const match=(style==='all'||card.dataset.style===style)&&(caffeine==='all'||card.dataset.caffeine===caffeine);card.hidden=!match;if(match)visible+=1});
    if(this.empty)this.empty.hidden=visible!==0;
    if(this.status)this.status.textContent=(this.dataset.countLabel||'{count} recipes').replace('{count}',visible);
  }
});

  } catch(e) { console.error(e); }
})();
})();
